// extracted by mini-css-extract-plugin
module.exports = {"backBtn":"BackBtn_backBtn__1bIB2"};